module.exports = __webpack_public_path__ + "static/media/103.b76744a0.jpg";